import { encode } from '..';
export var blockquote = function blockquote(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  var result = [];
  node.forEach(function (n) {
    result.push(encode(n, context));
  });
  return "{quote}".concat(result.join('\n\n'), "{quote}");
};